import type { ChatConfig } from './types';

export const defaultConfig: ChatConfig = {
  enableAudio: true,
  enablePodcast: true,
  enableStreaming: true,
  fallbackToNonStreaming: true,
  enableDarkMode: true,
  enableWelcomeView: true,
  enableClearButton: true,
  enableMinimizeButton: true,
  enableCopyButton: true,
  enableTimestamps: true,
  enableCharCounter: true,
  enableErrorOverlay: false,
  podcastTimeoutMs: 180_000,
  errorOverlayCountdownSec: 60,
  streamSmoothingMs: 200,
  colorModeStorageKey: 'xbot:color-mode',
};
